module.exports = __webpack_public_path__ + "mobile/img/crm-img11.329e7a9b.png";